export * from './auth.service';


// WEBPACK FOOTER //
// ./src/app/authorization/services/index.ts